/**
 * `settings_str` is a JSON string on the wire and an object in `BoardView.settings`; both are
 * accepted, and neither may throw — 190 of these rows come from a nine-year-old account.
 */
export function parseViewSettingsBlob(raw, kind) {
    const warnings = [];
    if (raw === null || raw === undefined || raw === '')
        return { object: {}, warnings };
    if (typeof raw === 'string') {
        try {
            const parsed = JSON.parse(raw);
            if (parsed === null || typeof parsed !== 'object' || Array.isArray(parsed)) {
                warnings.push(`${kind}: settings_str is not an object`);
                return { object: {}, warnings };
            }
            return { object: parsed, warnings };
        }
        catch {
            warnings.push(`${kind}: settings_str is not valid JSON`);
            return { object: {}, warnings };
        }
    }
    if (typeof raw !== 'object' || Array.isArray(raw)) {
        warnings.push(`${kind}: settings is not an object`);
        return { object: {}, warnings };
    }
    return { object: raw, warnings };
}
/**
 * Which of the keys we model monday actually stored. The exporter writes a modelled key back
 * only when monday had it or the value has since changed, so an imported view round-trips
 * byte for byte while a view configured in our own UI still saves what the user set.
 */
export function presentKeys(object, known) {
    const out = [];
    for (const key of known)
        if (Object.hasOwn(object, key))
            out.push(key);
    return out;
}
/** Everything monday stored that the kind's reader did not consume. */
export function extraKeys(object, known) {
    const out = {};
    for (const [key, value] of Object.entries(object))
        if (!known.has(key))
            out[key] = value;
    return out;
}
/**
 * **P-025.** An imported view row stores monday's `settings_str` *verbatim* — the importer keeps
 * the blob (X2 §16) and `views.settings` on the pilot database really does hold
 * `{"assignee_column":{"executor":true},"pivot_by_column":{"phase":true}}` for board
 * `174316936`'s kanban. Every kind's `normaliseSettings` merged that object over its canonical
 * defaults and let zod strip the snake_case keys, so the kanban opened with `pivotColumnId:
 * null` and drew one grey `Blank / 129` lane instead of monday's four status lanes.
 *
 * The fix is one line per kind rather than a migration: **a blob none of whose keys is one of
 * the kind's own fields is monday's, and is read with the kind's own reader.** The two shapes
 * cannot be confused — ours are camelCase field names (`pivotColumnId`), monday's are snake_case
 * (`pivot_by_column`) — and a partial patch from our settings pane always names one of our
 * fields, so it keeps the merge path it has always had.
 */
export function mondayShapedSettings(input, defaults, read) {
    if (input === null || typeof input !== 'object' || Array.isArray(input))
        return input;
    const keys = Object.keys(input);
    if (keys.length === 0)
        return input;
    const ours = new Set(Object.keys(defaults));
    if (keys.some((key) => ours.has(key)))
        return input;
    return read(input).settings;
}
//# sourceMappingURL=from-monday.js.map